import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import Container from '../Shared/Container';
import InnerContainer from '../Shared/InnerContainer';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

const Hero_Section = (props) => (
    <Container hero>
      <InnerContainer light centered>
        <HeroTitle>Amy E. Zimmerman, Ph.D.</HeroTitle>
        <HeroSubtitle>Microbial Ecology &amp; Biogeochemistry</HeroSubtitle>
        <SectionText dangerouslySetInnerHTML={ {__html: marked(props.text, {sanitize: true})}} />
        {/* <p>{props.text}</p> */}
      </InnerContainer>
  </Container>
);

export default Hero_Section;

// const Container = styled.div`
//   background: linear-gradient(rgba(46, 139, 87,.85),rgba(46, 139, 87,.85)),url(${logo});
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   padding: 10px;
//   height: 75vh;
//   min-height: 500px;
//   background-size: cover;
//   background-position: center;
//   background-repeat: no-repeat;
//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
// `;

// const InnerContainer = styled.div`
//   max-width: 960px;
//   margin: auto;
//   padding: 20px;
//   text-align: center;
//   color: white;
// `;

const HeroTitle = styled.h1`
  font-weight: 300;
  font-size: 4rem;
  line-height: 5.5rem;
  margin: 0;

  @media (max-width: 900px) {
    font-size: 3rem;
    line-height: 3.5rem;
  }

  @media (max-width: 600px) {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
`;

const HeroSubtitle = styled.h4`
  font-weight: 300;
  font-size: 2rem;
  line-height: 2.5rem;
  margin: 0 0 1rem;
  opacity: 1;
  ${'' /* text-transform: uppercase; */}

  @media (max-width: 900px) {
    margin: 0.5rem 0;
  }

  @media (max-width: 600px) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;

const SectionText = styled.div`
  line-height: 1.85rem;
  font-size: 1.35rem;
  font-family: Lato;
  font-weight: 300;
  letter-spacing: 0.25px;

  ${'' /* @media (max-width: 900px) {
    font-size: 2rem;
    line-height: 2.5rem;
  } */}

  @media (max-width: 600px) {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Hero_Section/index.js